import React from 'react';
import { motion } from 'framer-motion';
//data
import { CorporateUseCaseData } from '../../Data/UseCaseData';

import Slider from '@/Components/Slider';
import { CorporateSlideArray } from '@/Components/CorporateSlides';
import MetaHead from '@/Components/MetaHead';
import MainHeading from '@/Components/MainHeading';
import ContentText from '@/Components/ContentText';
import { Button } from '@/Components/Button';
import Link from 'next/link';

export default function CorporateUseCase() {
  return (
    <div>
      <MetaHead title="For Corporates and Companies | Fyllo" />
      <div className="py-8 px-4 mx-auto max-w-screen-xl text-left lg:py-16 lg:px-6">
        <div className="mx-auto max-w-screen-xl">
          <MainHeading text="For Contract/Corporate Farming Companies" />
        </div>
      </div>

      <div className="pb-10 grid md:grid-cols-2 gap-2 md:gap-10 mx-auto max-w-screen-xl p-5">
        {CorporateUseCaseData.map((content, i) => {
          if (CorporateUseCaseData.length - 1 !== i) {
            return (
              <div key={i} className="p-8 md:p-16 bg-slate-200 rounded-lg">
                <div className="text-7xl font-black text-slate-400">{`0${i + 1}.`}</div>
                <div className="pt-5">
                  <div className="  text-xl md:text-2xl font-bold text-green-800">{content.title}</div>
                  <ContentText text={content.description} />
                </div>
              </div>
            );
          }
        })}
      </div>
      <div className="mt-2 md:mt-10 px-8 md:px-56">
        <div className="p-8 md:p-16 bg-slate-200 rounded-lg">
          <div className="text-7xl font-black text-slate-400">{`05.`}</div>
          <div className="pt-5">
            <div className=" text-2xl font-bold text-green-800">
              {CorporateUseCaseData[CorporateUseCaseData.length - 1].title}
            </div>
            <div>{CorporateUseCaseData[CorporateUseCaseData.length - 1].description}</div>
          </div>
          <div className="pt-10">
            <Slider imgArray={CorporateSlideArray} />
          </div>
        </div>
      </div>
      <div className="grid place-items-center p-5">
        <Link href={'/contact#contact_form'}>
          <Button size="lg">Explore Partnership With Fyllo</Button>
        </Link>
      </div>
    </div>
  );
}
